import {
  AppointmentDependencyType,
  AppointmentStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  DayOfWeek,
  IAvroSerialisedVersionedSchema,
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import {
  IBigQueryEvent,
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  IBigQueryStatusHistory,
  ITimestampedDimension,
} from './common';
import { IBigQueryFollowUp } from './treatment-plan';

export interface IAppointmentDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  event?: IBigQueryEvent;
  eventHistory: IEventHistory[];
  status: AppointmentStatus;
  statusHistory: IBigQueryStatusHistory<AppointmentStatus>[];
  confirmedAt?: ISerialisedTimestamp;
  firstBookedAt?: ISerialisedTimestamp;
  lastBookedAt?: ISerialisedTimestamp;
  practitioner: IBigQueryNamedDocument;
  treatmentPlan: IBigQueryAssociatedTreatment;
  waitListItem?: IBigQueryWaitListItem;
  cancellationHistory: IBigQueryCancellation[];
  dependencies: IBigQueryAppointmentDependency[];
  deleted: boolean;
  clinicalChart?: ISerialisedDocumentReference;
  invoiceRef?: ISerialisedDocumentReference;
  activeFollowUp?: IBigQueryReffable & IBigQueryFollowUp;
  practice: IBigQueryNamedDocument;
  tags: IBigQueryNamedDocument[];
  appointmentRequest?: {
    bookedAt: ISerialisedTimestamp;
    ref: ISerialisedDocumentReference;
  };
}

interface IEventHistory {
  createdAt: ISerialisedTimestamp;
  event?: IBigQueryEvent;
}

export interface IBigQueryAssociatedTreatmentCategory
  extends IBigQueryNamedDocument {
  colour: {
    value: string;
    name: string;
  };
}

interface IBigQueryAssociatedTreatmentStep extends IBigQueryNamedDocument {
  duration: number;
  treatmentCategory?: IBigQueryAssociatedTreatmentCategory;
}

export interface IBigQueryAssociatedTreatment extends IBigQueryNamedDocument {
  treatmentStep: IBigQueryAssociatedTreatmentStep;
}

export interface IBigQueryWaitListItem {
  uid?: string;
  /**
   * WaitListUrgency is an invalid avro enum
   */
  urgency: number;
  inShortList?: boolean;
  dateFrom: ISerialisedTimestamp;
  dateTo: ISerialisedTimestamp;
  timeFrom: string;
  timeTo: string;
  days: DayOfWeek[];
  notes?: IAvroSerialisedVersionedSchema;
  availableDates: string[];
}

export interface IBigQueryCancellation {
  /**
   * CancellationReason is an invalid avro enum
   */
  reason: string;
  comments: IAvroSerialisedVersionedSchema;
}

export interface IBigQueryAppointmentDependency extends IBigQueryNamedDocument {
  type: AppointmentDependencyType;
}
